import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark py-12 md:py-16" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-71">
        <div className="text-center" data-id="element-72">
          <div className="font-display font-bold text-white text-xl mb-6" data-id="element-73">
            Digital Solvex
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-6" data-id="element-74">
            <a href="#" className="text-white/40 hover:text-white/60 text-sm transition-colors" data-id="element-75">
              Política de privacidad
            </a>
            <span className="text-white/20" data-id="element-76">|</span>
            <a href="#" className="text-white/40 hover:text-white/60 text-sm transition-colors" data-id="element-77">
              Términos y condiciones
            </a>
            <span className="text-white/20" data-id="element-78">|</span>
            <a href="#" className="text-white/40 hover:text-white/60 text-sm transition-colors" data-id="element-79">
              Política de reembolsos
            </a>
          </div>

          <p className="text-white/30 text-sm mb-4" data-id="element-80">
            © 2026 Digital Solvex · argentina.digitalsolvex.shop
          </p>

          <p className="text-white/20 text-xs max-w-xl mx-auto leading-relaxed" data-id="element-81">
            Este sitio no está afiliado ni patrocinado por Mercado Libre ni por
            ninguna empresa mencionada.
          </p>
        </div>
      </div>
    </footer>;
}